import { Injectable } from '@angular/core'
import { IndividualConfig, ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private toastrService: ToastrService) {}

  showError(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.error(message, title, config)
  }

  showSuccess(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.success(message, title, config)
  }

  showWarning(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.warning(message, title, config)
  }

  showInfo(message?: string, title?: string, config?: Partial<IndividualConfig>) {
    this.toastrService.info(message, title, config)
  }
}
